import { useState } from "react";
import { Box, Button, Icon, Text } from "@oneloop/jopijs";
import PickerWithInput from ".";
import styles from "./styles.module.scss";

function ImagePicker({ editor, handleDropdown }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleCloseImagePicker = () => {
    handleDropdown({ open: false });
  };

  const handlePressEscape = (event) => {
    if (event.key === "Escape") {
      event.stopPropagation();
      handleCloseImagePicker();
    }
  };

  const handleSubmit = (link) => {
    setIsLoading(true);
    const img = new Image();
    const alt = "image-to-send";
    const src = link;

    img.onload = function () {
      editor.chain().focus().setImage({ alt, src }).run();
      editor.chain().focus().setHardBreak().run();
      handleCloseImagePicker();
      setIsLoading(false);
    };

    img.onerror = function () {
      setIsError(true);
      setIsLoading(false);
    };

    img.src = src;
  };

  return (
    <Box className={styles.container} onKeyDown={handlePressEscape}>
      <Box className={styles.header}>
        <Text className={styles.title}>Attach Image</Text>
        <Icon
          icon="icon-cerrar"
          fontSize="12px"
          onClick={handleCloseImagePicker}
          className={styles["close-icon"]}
        />
      </Box>
      <Text className={styles.subtitle}>Attach an image or paste a link</Text>
      <Text className={styles.description}>
        {`You can upload the image to the file manager, within the 'My company' section, or provide a link to a publicly uploaded image on the internet`}
      </Text>

      {isError && (
        <Box className={styles["error-container"]}>
          <Icon icon="icon-error" fontSize="16px" color="#A71601" />
          <Box className={styles["error-text-wrapper"]}>
            <Text className={styles["error-title"]}>
              {`The image couldn't be attached.`}
            </Text>
            <Text className={styles["error-body"]}>
              Enter a public image or upload it to our file manager
            </Text>
          </Box>
          <Button
            variant="subtleText"
            className={styles["got-it-button"]}
            onClick={() => setIsError(false)}
          >
            Got it
          </Button>
        </Box>
      )}

      {!isError && (
        <PickerWithInput
          placeholder="Image link"
          onSubmit={handleSubmit}
          onCancel={handleCloseImagePicker}
          ctaText="Attach image"
          styles={{ maxWidth: "204px" }}
          isLoading={isLoading}
        />
      )}
    </Box>
  );
}

export default ImagePicker;
